import Select from "react-select";
import  "./form.scss";
import { getValue } from "@utils/lodash";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "react-datepicker/dist/react-datepicker-cssmodules.css";
import moment from "moment";
import { convertDateTime } from "common/date-helpers";
type Props = {
  disabled?: boolean;
  name?: string;
  type?: string;
  value: any;
  onChange: any;
  label: string;
  validator?: any;
  placeholder?: string;
  mandatory?: boolean;
  maxDate?: any;
  minDate?: any;
  hideLabel?: boolean;
  showTimeSelectOnly?: boolean;
  showTimeInput?: boolean;
  timeIntervals?: number;
};

export default function TimePicker({
  disabled,
  name,
  type,
  value,
  onChange,
  validator,
  label,
  placeholder,
  mandatory,
  maxDate,
  minDate,
  hideLabel,
  showTimeSelectOnly,
  showTimeInput,
  timeIntervals = 1,
}: Props) {
  const parseValueToDate = (val: any) => {
    if (!val) return null;
    if (val instanceof Date) return isNaN(val.getTime()) ? null : val;
    const m = moment(val, [
      moment.ISO_8601,
      "hh:mm a",
      "hh:mm A",
      "HH:mm",
      "HH:mm:ss",
      "YYYY-MM-DDTHH:mm:ssZ",
    ]);
    return m.isValid() ? m.toDate() : null;
  };

  return (
    <div
      // className={`${"signup-form-wrapper__form-group"} ${
      //   validator && validator.current.message(label, value, "required")
      //     ? "signup-form-wrapper__form-group--error"
      //     : ""
      // } form-group mb-3`}
    >
      {!hideLabel && (
        <label className={mandatory ? "form-label-error" : "form-label"}>
          {label} {mandatory && "*"}
        </label>
      )}
      <div>
        <DatePicker
          className={`${"custom-form-control"} form-control`}
          selected={parseValueToDate(value)}
          onChange={onChange}
          placeholderText={
            placeholder || (showTimeSelectOnly ? "hh:mm aa" : "d MMM yyyy, p")
          }
          showTimeSelect
          showTimeSelectOnly={showTimeSelectOnly}
          timeIntervals={timeIntervals}
          dateFormat={showTimeSelectOnly ? "hh:mm aa" : "d MMM yyyy, p"}
          timeCaption="Time"
          disabled={disabled}
        />
      </div>
      {validator && (
        <p className={`${"error-text"} text-center`}>
          {validator.current.message(label, value, "required")}
        </p>
      )}
    </div>
  );
}
